import React from 'react';

import { Column, CustomDRTReportItem } from '../../../../utils/models';
import { concatClassNames, formatTime } from '../../../../utils/utilities';
import { APP_DATE_FORMAT } from '../../../../utils/constants';
import { getResultItemStyle } from '../../../../utils/data';

import Conditional from '../../../common/conditional';
import PAUTConstraint from '../../custom-paut/paut-constraint';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import classNames from './style.module.scss';

const DRTDataPage: React.FC<CustomDRTReportItem> = (props) => {
	return (
		<div className={classNames.drtDataPage}>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col p-0">
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>Source</div>
							<div className={classNames.drtDataPageItemRight}>{props.source}</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Source Activity
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.sourceActivity}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>Source Size</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.sourceSize}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								DRT Scanner Modal Name
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.drtScannerModalName}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>RT Technique</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.rtTechnique}
							</div>
						</div>
					</div>
					<div className="col p-0">
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>Serial Number</div>
							<div className={classNames.drtDataPageItemRight}>{props.equipmentSerialNumber}</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>SDD</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.sdd}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>ODD</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.odd}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								IQI
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.iqi}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								IQI Type
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.iqiType}
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col p-0">
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								IQI Specification
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.iqiSpecification}
							</div>
						</div>
					</div>

					<div className="col p-0">
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Pipe Material Class
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.pipeMaterialClass}
							</div>
						</div>
					</div>
				</div>
			</div>

			<Conditional isVisible={false}>
				<div className={classNames.drtDataPageSeparator}></div>
			</Conditional>
			
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col p-0">
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Image Type
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.imageFilmType}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Source Conformity Inspection Date
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.sourceConformityInspectionDate ? formatTime(props.sourceConformityInspectionDate, APP_DATE_FORMAT) : 'N/A'}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>Contrast Used</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.contrastUsed}
							</div>
						</div>
					</div>
					<div className="col p-0">
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Source Manufacturer
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.sourceManufacturer}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Material Specification
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.pipeSpecification}
							</div>
						</div>
						<div className={classNames.drtDataPageItem}>
							<div className={classNames.drtDataPageItemLeft}>
								Serial Number
							</div>
							<div className={classNames.drtDataPageItemRight}>
								{props.serialNumber}
							</div>
						</div>
					</div>
				</div>
			</div>

			<Conditional isVisible={false}>
				<div className={classNames.drtDataPageSeparator}></div>
			</Conditional>

			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className={concatClassNames([classNames.drtDataPageItem, 'col p-0'])}>
						<div className={classNames.drtDataPageItemLeft}>
							Date of Inspection
						</div>
						<div className={classNames.drtDataPageItemRight}>
							{props.inspectionDate ? formatTime(props.inspectionDate, APP_DATE_FORMAT) : 'N/A'}
						</div>
					</div>
					<div className={concatClassNames([classNames.drtDataPageItem, 'col p-0'])}>
						<div className={classNames.drtDataPageItemLeft}>
							DRT Scanner Calibration Due Date
						</div>
						<div className={classNames.drtDataPageItemRight}>
							{props.drtScannerCalibrationDate ? formatTime(props.drtScannerCalibrationDate, APP_DATE_FORMAT) : 'N/A'}
						</div>
					</div>
				</div>
			</div>

			<Conditional isVisible={false}>
				<div className={classNames.drtDataPageSeparator}></div>
			</Conditional>

			<div className="container-fluid overflow-hidden p-0">
				<div className={classNames.drtDataPageSynonyms}>
					SDD = SFD = Source to detector distance; ODD = OFD = Object to
					detector distance TDW = Tangential Double Wall (TDW) Technique
				</div>
			</div>

			<div className={classNames.drtDataPageTitle}>Result</div>
			
			<div className="d-flex justify-content-start align-items-center">
				<div className={concatClassNames([classNames.drtDataPageSN, 'flex-fill'])}>
					<div className={classNames.drtDataPageSNLeft}>Weld Number</div>
					<div className={concatClassNames([classNames.drtDataPageSNRight, classNames.drtDataPageSNRightBordered])}>{props.weldNumber}</div>
				</div>
				<div className={concatClassNames([classNames.drtDataPageSN, 'flex-fill'])}>
					<div className={classNames.drtDataPageSNLeft}>DRT Shot Number</div>
					<div className={classNames.drtDataPageSNRight}>{props.shotNumber}</div>
				</div>
			</div>

			{props.image && props.image.length > 0 && (
				<div className={classNames.drtDataPageImage}>
					<img src={props.image[0].src} alt={props.image[0].caption} />
				</div>
			)}

			<Conditional isVisible={!props.image || props.image.length === 0}>
				<PAUTConstraint />
			</Conditional>

			<div className={classNames.drtDataPageBottom}>
				<PDFTablePage
					columns={columns}
					data={[
						{
							thickness: props.thickness,
							pipeDia: props.pipeDia,
							defect: props.defect,
							defectType: props.defectType,
							result: props.result,
							defectLength: props.defectLength,
						},
					]}
				/>

				<div className={classNames.drtDataPageLimitation}>
					LIMITATION (IF ANY):
				</div>
			</div>
		</div>
	);
};

const columns: Column[] = [
	{
		path: 'thickness',
		label: 'Thickness (mm)',
	},
	{
		path: 'pipeDia',
		label: 'Pipe Dia (Inch)',
	},
	{
		path: 'defect',
		label: 'DEFECT',
	},
	{
		path: 'defectType',
		label: 'DEFECT TYPE',
	},
	{
		path: 'result',
		label: 'RESULT',
		style: (item: any) => getResultItemStyle(item),
	},
	{
		path: 'defectLength',
		label: 'DEFECT LENGTH (mm)',
	},
];

export default DRTDataPage;
